import { supabase } from './client';

export type AdminUsersAction = 'create_student' | 'create_teacher' | 'update_email' | 'delete_teacher';

/**
 * Calls the admin-users Edge Function, which holds the service-role key and
 * checks the caller's permissions. Throws the function's own error message.
 */
export async function invokeAdminUsers<T = any>(action: AdminUsersAction, payload: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('admin-users', { body: { action, ...payload } });
  if (error) {
    const body = await error.context?.json?.().catch(() => null);
    throw new Error(body?.error || error.message);
  }
  return data as T;
}
